<div class="col-md-12 mb-30">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0">Withdrawal List</h5>

      <br />
      <br />

      <div class="row">
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">Time Range</label>
          <select class="custom-select" [(ngModel)]="SubmitPeriodDate" name="SubmitPeriodDate">
            <option value="1">Apply</option>
            <option value="0">Do Not Apply</option>
          </select>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">Start Date</label>
          <input type="text" #datepickerInputStart placeholder="Type here..." class="form-control" />
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
            [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputStart"></ng-persian-datepicker>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">End Date</label>
          <input type="text" #datepickerInputEnd placeholder="Type here..." class="form-control" />
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
            [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputEnd"></ng-persian-datepicker>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">User</label>
          <input [(ngModel)]="Filter_Schedule_User" name="Filter_Schedule_User" type="text" class="form-control"
            placeholder="Type here to search...">
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">Customer Name</label>
          <input [(ngModel)]="Filter_Customer_Name" name="Filter_Customer_Name" type="text" class="form-control"
            placeholder="Type here to search...">
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">Letter Number</label>
          <input [(ngModel)]="Filter_Letter_Code" name="Filter_Letter_Code" type="text" class="form-control"
            placeholder="Type here to search...">
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">Decree Number</label>
          <input [(ngModel)]="Filter_Schedule_Code" name="Filter_Schedule_Code" type="text" class="form-control"
            placeholder="Type here to search...">
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">Status</label>
          <select [(ngModel)]="Filter_Status" name="Filter_Status" class="custom-select">
            <option value="-2">All</option>
            <option value="0">Under Review</option>
            <option value="1">Approved</option>
            <option value="-1">Rejected</option>
          </select>
        </div>
      </div>

      <div class="row">
        <div class="form-group col-md-12">
          <button *ngIf="!Procssing" type="button"
            (click)="ReadData_Funds(datepickerInputStart.value,datepickerInputEnd.value)" class="btn btn-info"
            style="margin-right: 5px;"><i class="fa  fa-search"></i> Search </button>
          <button *ngIf="!Procssing" (click)="exportexcel()" type="button" class="btn btn-warning"
            style="margin-right: 5px;"><i class="fa   fa-file-excel-o"></i> Excel </button>
          <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />

          <label style="font-weight: bolder;">Grand Total : {{DataList_Funds_Charge_Price|number}}</label>
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>ID</th>
              <th>Customer Name</th>
              <th>Letter Number</th>
              <th>Decree Number</th>
              <th>Expense Amount (IRR)</th>
              <th>Expense Date</th>
              <th>Expense Title</th>
              <th>Description</th>
              <th>Attachment</th>
              <th>Status</th>
              <th>Date</th>
              <th>User</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Funds_Charge
            |filter:Filter_Schedule_Code:'code2'
            |filter:Filter_Letter_Code:'code3'
            |filter:Filter_Customer_Name:'customer'
            | paginate
                    : {
                        id: 'DataList_UserTable_Charge',
                        itemsPerPage: 10,
                        currentPage: page_Charge,
                        totalItems: (DataList_Funds_Charge
                        |filter:Filter_Schedule_Code:'code2'
                        |filter:Filter_Letter_Code:'code3'
                        |filter:Filter_Customer_Name:'customer').length
                      }
            ">
            <td>{{DataList_Funds_Charge.indexOf(item)+1}}</td>
            <td>{{item.code}}</td>
            <td>{{item.customer}}</td>
            <td>{{item.code3}}</td>
            <td>{{item.code2}}</td>
            <td>{{item.price | number}}</td>
            <td>{{item.price_date}}</td>
            <td>{{item.title}}</td>
            <td>{{item.dsc}}</td>
            <td>
             <a class="dropdown-item" target="_blank" href="{{BaseUrl}}File/Funds/{{item.src}}"   *ngIf="item.src" ><i class="fa fa-download"></i> Download </a>
            </td>
            <td>
             <p *ngIf="item.status==0" style="color: #39539b;">Under Review</p>
             <p *ngIf="item.status==1" style="color: 489b39;">Approved</p>
             <p *ngIf="item.status==-1" style="color: crimson;">Rejected</p>
            </td>
            <td>{{item.subdate}}</td>
            <td>{{item.username}}</td>
            </tr>
          </tbody>

        </table>
      </div>

      <pagination-controls id="DataList_UserTable_Charge" nextLabel="Next" previousLabel="Previous"
        (pageChange)="page_Charge = $event"></pagination-controls>
    </div>
  </div>
</div>


<table id="excel-table" style="display: none;">
  <thead>
    <tr>
      <th>ID</th>
      <th>Customer Name</th>
      <th>Letter Number</th>
      <th>Decree Number</th>
      <th>Expense Amount (IRR)</th>
      <th>Expense Date</th>
      <th>Expense Title</th>
      <th>Description</th>
      <th>Status</th>
      <th>Date</th>
      <th>User</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of DataList_Funds_Charge
    |filter:Filter_Schedule_Code:'code2'
    |filter:Filter_Letter_Code:'code3'
    |filter:Filter_Customer_Name:'customer'">

        <td>{{item.code}}</td>
        <td>{{item.customer}}</td>
        <td>{{item.code3}}</td>
        <td>{{item.code2}}</td>
        <td>{{item.price | number}}</td>
        <td>{{item.price_date}}</td>
        <td>{{item.title}}</td>
        <td>{{item.dsc}}</td>
        <td>
        <p *ngIf="item.status==0" style="color: #39539b;">Under Review</p>
        <p *ngIf="item.status==1" style="color: 489b39;">Approved</p>
        <p *ngIf="item.status==-1" style="color: crimson;">Rejected</p>
        </td>
        <td>{{item.subdate}}</td>
        <td>{{item.username}}</td>
    </tr>
  </tbody>
</table>
